import { Input } from "@loot-os/ui/components/input";
import { Label } from "@loot-os/ui/components/label";

import { centsToDollars } from "../lib/format";
import {
  PAID_COST_FIELDS,
  type PaidCostDollars,
  type PaidCostField,
  typedCheckoutTotalCents,
} from "../lib/paidCosts";

/**
 * One StockX line's paid-cost fields, labelled and ordered as the StockX order details page lists
 * them (Kai 2026-10-28), with the total they add up to beside them, so staff check it against
 * StockX's Total (the card charge) before they move the order on.
 */
export function StockxPaidCostFields({
  lineId,
  label,
  dollars,
  disabled,
  onChange,
}: {
  lineId: string;
  label: string;
  dollars: PaidCostDollars;
  disabled: boolean;
  onChange: (key: PaidCostField["key"], value: string) => void;
}) {
  const totalCents = typedCheckoutTotalCents(dollars);
  return (
    <fieldset className="grid gap-2">
      <legend className="text-sm font-medium">{label}</legend>
      {PAID_COST_FIELDS.map((field) => {
        const id = `paid-cost-${lineId}-${field.key}`;
        return (
          <div key={field.key} className="grid gap-1">
            <Label htmlFor={id}>
              {field.label} (USD){field.isOptional ? ", optional" : ""}
            </Label>
            {field.help ? (
              <p id={`${id}-help`} className="text-xs text-muted-foreground">
                {field.help}
              </p>
            ) : null}
            <Input
              id={id}
              inputMode="decimal"
              placeholder="0.00"
              aria-describedby={field.help ? `${id}-help` : undefined}
              value={dollars[field.key] ?? ""}
              disabled={disabled}
              onChange={(e) => onChange(field.key, e.target.value)}
            />
          </div>
        );
      })}
      <p id={`paid-cost-${lineId}-total`} className="text-sm">
        Total: {totalCents === null ? "enter the amounts above" : centsToDollars(totalCents)}
      </p>
    </fieldset>
  );
}
